exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field{padding:5px 0}.field__wrapper{position:relative;width:100%}.field__wrapper--with-icon .password-icon{position:absolute;right:0;top:55%;transform:translateY(-50%);height:45px;width:60px;display:flex;justify-content:center;align-items:center;cursor:pointer;color:#bfbfbf}@media (prefers-color-scheme: dark){:root:not([data-theme=light]):not([data-theme=dark]) .field__wrapper--with-icon .password-icon{color:#333}}:root[data-theme=dark] .field__wrapper--with-icon .password-icon{color:#333}.field__message{color:#cb1f27;font-size:14.864px;font-size:0.929rem;margin:1px 12px 0;min-height:16px}.field__select{display:flex}\n", ""]);

// exports
exports.locals = {
	"field": "field",
	"field__wrapper": "field__wrapper",
	"field__wrapper--with-icon": "field__wrapper--with-icon",
	"password-icon": "password-icon",
	"field__message": "field__message",
	"field__select": "field__select"
};